module.exports = __webpack_public_path__ + "img/mail.428014fe.png";